import { Component, input, output } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatPrefix, MatSuffix } from '@angular/material/form-field';
import { ViewModelProperty } from '../../models';
import { BaseEdit } from '../base-edit';

import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'ldw-button-edit',
  templateUrl: './button-edit.component.html',
  styleUrls: ['./button-edit.component.css'],
  imports: [
    ReactiveFormsModule,
    MatFormField,
    MatIcon,
    MatPrefix,
    MatTooltip,
    MatInput,
    MatIconButton,
    MatSuffix,
    MatProgressBar
  ]
})
export class ButtonEditComponent extends BaseEdit {
  readonly clearButtonEnabled = input(false);
  readonly actionClicked = output<ViewModelProperty>();
}
